import axios from "@/config/axios-instance";
import { useMutation } from "vue-query";

const usePrivateEventService = () => {

    //Submit Contact Us
    const useHandlePrivateEventFormService = () => {
        const handlePrivateEvent = (data) => {
            return axios.post(`/private-event/request/`,data)
        }
        const onSuccess = () => {
            // useToaster("success","",)

        }
        const onError =() => {
            // useToaster("danger","","Form Not Submitted Successfully")

        }


        return useMutation(
            (privateEventData) => handlePrivateEvent(privateEventData),
            {
                onSuccess,
                onError,
                retry:0
            }
        )

    }

    return {useHandlePrivateEventFormService}
};

export default usePrivateEventService;
